import React, { forwardRef, useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";
import { Colors } from '../../../constants';
import { useTranslation } from 'react-i18next';

const PhoneDefaultElement = forwardRef((props, ref) => {
    const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);
    const { t } = useTranslation();

    useEffect(() => {
        setFocusBorderColor(`#${Colors.disabledText}`);
    },
    []);

    const permittedCountries = [...props.permittedCountries.map(v => v.toLowerCase())]
    const showOnlyPermittedCountries = props.customDisplayedCountries
    let settingCountryCode = props.defaultCountry.toLowerCase() || props.countryCode
    if(settingCountryCode === 'geo'){
        settingCountryCode = props.countryCode

        if(showOnlyPermittedCountries){
            settingCountryCode = permittedCountries[0] || props.countryCode
        }
    }

    return (
        <div className="input-section" key={props.index}>
            <div className="input-nav field-label">
                <label>
                    {t('Phone Number')}
                    <span className="required" style={{ color: props.color }}> *</span>
                </label>
                <div className="field-input phone-number">
                    <PhoneInput
                        ref={ref}
                        inputClass={'phone-number-input'}
                        containerStyle={{width: '100%', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px'}}
                        searchStyle={{ width:"150px", }}
                        dropdownStyle={{ width:"250px",height:"130px", textAlign: 'left' }}
                        buttonStyle={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'transparent' }}
                        inputStyle={{
                            height:"43px",
                            width: "100%",
                            paddingLeft: '43px',
                            // zIndex: 99,
                            // borderTopLeftRadius: '0px',
                            // borderBottomLeftRadius: '0px',
                            borderColor: focusBorderColor
                        }}
                        onFocus={ () => setFocusBorderColor(props.color) }
                        onBlur={ () => setFocusBorderColor(`#${Colors.disabledText}`) }
                        inputProps={{required: true}}
                        enableSearchField={true}
                        country={settingCountryCode}
                        specialLabel={' '}
                        value={props.number || ''}
                        prefix={'+'}
                        autocompleteSearch={true}
                        onlyCountries={showOnlyPermittedCountries ? permittedCountries : []}
                        onChange={(value) => props.handleOnChange(value)}/>
                </div>
            </div>
        </div>
    )

});

export default PhoneDefaultElement;
